import { FC } from 'react';
import { Box } from '@mui/material';
import { DataNode } from '../interfaces/TreeNode';
import BankData from './data/BankData';
import CityAccommodation from './data/CityAccommodation';
import CreditCardData from './data/CreditCardData';
import HelpItemData from './data/HelpItemData';
import GatheringData from './data/GatheringData';
import URLData from './data/URLData';
import SMSData from './data/SMSData';
import BloodDonationData from './data/BloodDonationData';
import TelephoneData from './data/PhoneData';
import ArticleData from './data/ArticleData';
import UsefulLinksData from './data/UsefulLinksdata';
import StemCellData from './data/StemCellData';
import VetData from './data/VetData';
import FoodDistributionData from './data/FoodDistributionData';
import VpnData from './data/VpnData';
import ContainerPharmacyData from './data/ContainerPharmacyData';

const pageMappings: Record<string, FC<{value: any}>> = {
  'bank-account-donation': BankData,
  'beneficial-articles': ArticleData,
  'blood-donationlist': BloodDonationData,
  'city-accommodation': CityAccommodation,
  'credit-card-donation': CreditCardData,
  'international-bank-account-donation': BankData,
  'international-url-donation': URLData,
  'new-gathering-list': GatheringData,
  'help-item-list': HelpItemData,
  'phone-number-list': TelephoneData,
  'sms-donation': SMSData,
  'url-donation': URLData,
  'useful-links': UsefulLinksData,
  'stem-cell-donation': StemCellData,
  'data-vet': VetData,
  'food-items': FoodDistributionData,
  'vpn': VpnData,
  'container-pharmacy': ContainerPharmacyData,
}

export default function Data({ dataNode }: { dataNode: DataNode }) {
  const renderData = () => {
    const Page = pageMappings[dataNode.data.dataType];

    return Page ? <Page value={dataNode.data} /> : <>Not found</>;
  };

  return (
    <Box
      sx={{
        textAlign: 'center',
        display: 'flex',
        flexFlow: 'column nowrap',
        justifyContent: 'center',
        alignItems: 'center',
        paddingBottom: '50px',
      }}
    >
      {renderData()}
    </Box>
  );
}
